import {
    TEAM_DELETE_FAILURE,
    TEAM_DELETE_REQUEST,
    TEAM_DELETE_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const deleteReducer = (state = initialState, action) => {
    const {type} = action;
    switch (type) {
        case TEAM_DELETE_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
        }}

        case TEAM_DELETE_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case TEAM_DELETE_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
